module.exports = __webpack_public_path__ + "img/scissors-light.18efd103.svg";